/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type LeaderboardRankingOrder = typeof LeaderboardRankingOrder[keyof typeof LeaderboardRankingOrder];


export const LeaderboardRankingOrder = {
  SmallerIsBetter: 'SmallerIsBetter',
  BiggerIsBetter: 'BiggerIsBetter',
} as const;
